const t = {
  name: "Terminal3",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.25 17C11.25 17.6904 10.6904 18.25 10 18.25C9.30964 18.25 8.75 17.6904 8.75 17C8.75 16.3096 9.30964 15.75 10 15.75C10.6904 15.75 11.25 16.3096 11.25 17Z" fill="currentColor"/>
<path d="M1 5C1 3.34315 2.34315 2 4 2H16C17.6569 2 19 3.34315 19 5V19C19 20.6569 17.6569 22 16 22H4C2.34315 22 1 20.6569 1 19V5ZM3 5V12H17V5C17 4.44772 16.5523 4 16 4H4C3.44772 4 3 4.44772 3 5ZM17 14H3V19C3 19.5523 3.44772 20 4 20H16C16.5523 20 17 19.5523 17 19V14Z" fill="currentColor"/>
<path d="M21 5H23V19H21V5Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Terminal3
};
